// extracted by mini-css-extract-plugin
export default {"edit-img":"EditImg_edit-img__AkgNf","edit-spn":"EditImg_edit-spn__eixpX"};